import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { RedirectToSignIn, useAuth } from '../lib/auth';
import { SESSION_EXPIRED_EVENT } from '../lib/api/sessionExpired';

/** Quietly reuse an existing session; never start an interactive sign-in. */
export function ExtensionSessionPage() {
  const { isLoaded, isSignedIn } = useAuth();
  const { pathname, search } = useLocation();
  // Extensions through 1.2.94 open /get-started?oqa_auto_auth=… in a background
  // tab and only learn "nobody is signed in" by seeing it land on /sign-in
  // (idleAuthBridge isSignInPage); they never hear OVERLAYQA_SESSION_UNAVAILABLE,
  // so without this each attempt waits out its 60 s deadline. They close that
  // background tab as soon as it reaches sign-in. The reinstall welcome tab
  // (no oqa_auto_auth) and /extension-session stay quiet.
  const legacyRecoveryTab = pathname === '/get-started' && new URLSearchParams(search).has('oqa_auto_auth');
  useEffect(() => {
    const unavailable = () => window.postMessage({ type: 'OVERLAYQA_SESSION_UNAVAILABLE' }, window.location.origin);
    const onRequest = (event: MessageEvent) => {
      if (event.source === window && event.origin === window.location.origin &&
          event.data?.type === 'OVERLAYQA_AUTH_REQUEST' && isLoaded && !isSignedIn) unavailable();
    };
    if (isLoaded && !isSignedIn) unavailable();
    window.addEventListener('message', onRequest);
    window.addEventListener(SESSION_EXPIRED_EVENT, unavailable);
    return () => {
      window.removeEventListener('message', onRequest);
      window.removeEventListener(SESSION_EXPIRED_EVENT, unavailable);
    };
  }, [isLoaded, isSignedIn]);
  if (legacyRecoveryTab && isLoaded && !isSignedIn) return <RedirectToSignIn />;
  // App's existing bridge transfers authenticated credentials. The extension
  // owns the attempt deadline and closes only its own inactive temporary tab.
  return null;
}
